import { Edit3, ShoppingBag, Trash2, Truck } from "lucide-react";
import { Badge } from "../ui/badge";

export default function CatalogSupplierRow({ supplier, productCount, isMain, onEdit, onAskDelete }) {
  const delivered = supplier.type === "delivered";
  return (
    <div
      className="flex items-center gap-3 md:gap-4 px-4 md:px-5 py-4 hover:bg-[#FBF8F1] transition-colors"
      data-testid={`supplier-row-${supplier.id}`}
    >
      <div
        className={`h-10 w-10 rounded-full flex items-center justify-center shrink-0 ${
          delivered ? "bg-[#E3F0EC] text-[#2B7A6B]" : "bg-[#F7E4DB] text-[#C4552B]"
        }`}
      >
        {delivered ? <Truck size={18} strokeWidth={1.8} /> : <ShoppingBag size={18} strokeWidth={1.8} />}
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <p className="text-sm font-medium text-[#0B1F3A]">{supplier.name}</p>
          <Badge
            variant="outline"
            className={
              delivered
                ? "border-[#2B7A6B]/40 text-[#2B7A6B] bg-[#E3F0EC]"
                : "border-[#C4552B]/40 text-[#C4552B] bg-[#F7E4DB]"
            }
          >
            {delivered ? "Delivered" : "Direct"}
          </Badge>
        </div>
        <p className="text-xs text-[#0B1F3A]/60 mt-0.5">
          {supplier.lead} · {productCount} product{productCount === 1 ? "" : "s"}
        </p>
      </div>
      {isMain && (
        <div className="flex gap-1 shrink-0">
          <button
            onClick={onEdit}
            className="h-8 w-8 rounded-md hover:bg-[#F3EFE7] flex items-center justify-center text-[#0B1F3A]/70 hover:text-[#0B1F3A] transition-colors"
            title="Edit"
            data-testid={`supplier-edit-${supplier.id}`}
          >
            <Edit3 size={14} />
          </button>
          <button
            onClick={onAskDelete}
            className="h-8 w-8 rounded-md hover:bg-red-50 flex items-center justify-center text-[#0B1F3A]/60 hover:text-red-600 transition-colors"
            title="Delete"
            data-testid={`supplier-delete-${supplier.id}`}
          >
            <Trash2 size={14} />
          </button>
        </div>
      )}
    </div>
  );
}
